export const LOGOUT = 'LOGOUT';

export const SET_MODULE_LABELS_CATEGORIES = 'SET_MODULE_LABELS_CATEGORIES';

export const SET_MODULE_LABELS_CATEGORIES_LOADING =
  'SET_MODULE_LABELS_CATEGORIES_LOADING';
